import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../../shared/models/component-messages/formfnsimplerectificatif/step3';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { Rectificatif } from '../../models/Rectificatif';
@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html'
})
export class Step3Component implements OnInit {

  @Input() rectificatif: Rectificatif;
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;


	@Input() uid = '';
  @Input() linkForRouter: string;
  public step3 = new Step3();

	constructor() { }


  ngOnInit(): void {
  }

  public getUid() {
    return this.uid;
  }

  public getUidNatureMarche() {
    return this.getUid() + "_SepSep_TypeDescMarche";
  }

}
